import { faCheckCircle, faExclamationCircle, faInfoCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import { ProgressBar, Toast } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { COOKIE_DOWNTIME_NOTIFICATION_SHOWN, DOWNTIME_NOTIFICATION_MESSAGE } from "../../common/constant";

const errorTypeMapping = {
  error: "danger",
  backend: "danger"
};

const iconMapping = {
  backend: <FontAwesomeIcon icon={faTimesCircle} />,
  error: <FontAwesomeIcon icon={faTimesCircle} />,
  warning: <FontAwesomeIcon icon={faExclamationCircle} />,
  info: <FontAwesomeIcon icon={faInfoCircle} />,
  success: <FontAwesomeIcon icon={faCheckCircle} />
};

const delay = 7000;
const rate = 100;
const initialMountDelay = 500;
const countdownSeverities = Object.keys(errorTypeMapping);
const cookies = new Cookies();

const Message = ({ clearMessage, index, message }) => {
  const intl = useIntl();
  const [currDelay, setCurrDelay] = useState(delay - initialMountDelay);
  const severity = message.severity;
  const isDowntimeNotification = message.message === DOWNTIME_NOTIFICATION_MESSAGE;
  const titleSeverity = isDowntimeNotification ? "info" : severity;
  const showCountdown = !isDowntimeNotification && !countdownSeverities.includes(severity);

  const closeMessage = () => {
    if (isDowntimeNotification) {
      const now = new Date();
      cookies.set(COOKIE_DOWNTIME_NOTIFICATION_SHOWN, getDateKey(now), {
        path: "/",
        maxAge: getSecondsUntilTomorrow(now)
      });
    }

    clearMessage(index);
  };

  useEffect(() => {
    let it;
    if (showCountdown) {
      it = setInterval(() => {
        setCurrDelay((curr) => curr - rate);
      }, rate);
    }

    return () => {
      if (it) {
        clearInterval(it);
      }
    };
  }, [showCountdown]);

  return message.message in intl.messages || severity === "backend" ? (
    <Toast
      onClose={closeMessage}
      className="messages"
      animation
      autohide={showCountdown}
      delay={showCountdown ? delay : undefined}
    >
      <Toast.Header className={"text-white bg-" + (errorTypeMapping[severity] || severity)}>
        {iconMapping[severity]}
        <strong className="ms-2 me-auto">
          <FormattedMessage id={"app.common.title." + titleSeverity} />
        </strong>
      </Toast.Header>
      {showCountdown && (
        <ProgressBar
          className="w-100"
          style={{ height: "2px" }}
          variant={errorTypeMapping[severity]}
          min={0}
          max={delay - initialMountDelay}
          now={currDelay}
        />
      )}
      <Toast.Body>
        <FormattedMessage id={message.message || `app.common.msg.${severity}`} />
      </Toast.Body>
    </Toast>
  ) : (
    <></>
  );
};

function getDateKey(date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

function getSecondsUntilTomorrow(date) {
  const tomorrow = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
  return Math.max(60, Math.ceil((tomorrow.getTime() - date.getTime()) / 1000));
}

Message.propTypes = {
  index: PropTypes.number.isRequired,
  message: PropTypes.object.isRequired,
  clearMessage: PropTypes.func.isRequired
};

export default Message;
